/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { 
  useGET_setupOptionsQuery,
  usePOST_setupOptionEnableMutation,
  usePOST_setupOptionDisableMutation 
} from 'redux/api/setupApi'

import { Form, Formik } from 'formik'
import CheckboxField from 'components/atoms/fields/CheckboxField'

const ProgramsSetupForm: FC = () => {
   const { t } = useTranslation()
   
   const { data: setupData } = useGET_setupOptionsQuery()
   const [enableOption, {isLoading: isEnableLoading, isSuccess: isEnableSuccess, error: enableError}] = usePOST_setupOptionEnableMutation()
   const [disableOption, {isLoading: isDisableLoading, isSuccess: isDisableSuccess, error: disableError}] = usePOST_setupOptionDisableMutation()
 
 
   const setupOptions = [
     {key: 'programs_accommodations', label: t('common.accommodations')},
     {key: 'programs_modifications', label: t('common.modifications')},
     {key: 'programs_strategies', label: t('common.instructional-strategies')},
     {key: 'programs_steps', label: t('common.dynamic-learning-path')}
   ]
 
   const serverValues = setupData ? {
     options:
       setupOptions.map(o => {
         return {
           ...o,
           is_enabled: setupData.filter(s => s.slug == o.key && s.is_enabled).length == 1
         }
       })
   } : null
 
   
   return (
 
     <>{serverValues &&
     <Formik
       enableReinitialize
       initialValues={serverValues}
       onSubmit={(values) => {
       }}
     >
       {
         ({ values, setFieldValue, errors }) => 
         <Form>
          
              {values["options"].map((option,index) => 
                <div key={index} style={{ maxWidth: '300px'}}>
                  <CheckboxField 
                    isSwitch={true}
                    hasLine={true}
                    index={index}
                    valueSelector='is_enabled'
                    fieldProps={{
                      label: option.label,
                      name: `options[${index}]`
                    }} 
                    onChange={(value)=> {
                      if(value.is_enabled)enableOption(option.key)
                      else disableOption(option.key)
                    }}
                  />
                </div>
                )}
          
           
         </Form>
       }
     </Formik>
     }</>
  )
}
export default ProgramsSetupForm

